// New deck drafts (plan elegant-sprouting-riddle, orchestrator decision
// 2026-11-01). saved_decks.bracket / analysis are NOT NULL, and shipped iOS
// 2.3 decodes bracket as a non-optional Int, so a draft is NEVER a row with
// null columns. It is a row with a REAL analysis of its partial contents
// (the normal /decks/analyze-complete path), marked inside the analysis JSON:
//
//   analysis.draft = true, analysis.draft_card_count = N
//
// Old clients ignore the unknown keys and show the real (partial) rating.
// This client reads `draft === true` as "Not analyzed yet": no bracket, no
// verdict, an Analyze action. The flag goes ONLY on an explicit Analyze (a
// fresh API response carries no `draft`). Automatic re-ratings of a draft
// (closing the editor) keep it.
import type { CompleteAnalysis } from '../api/types'

export function isDraftAnalysis(analysis: CompleteAnalysis | null | undefined): boolean {
  return !!analysis && (analysis as { draft?: unknown }).draft === true
}

/** The analysis as a draft holding `cardCount` cards (command zone included). */
export function markDraft(analysis: CompleteAnalysis, cardCount: number): CompleteAnalysis {
  return { ...analysis, draft: true, draft_card_count: cardCount }
}

/** `next` carrying `prev`'s draft mark, when `prev` was a draft (automatic re-ratings). */
export function keepDraftOf(prev: CompleteAnalysis | null | undefined, next: CompleteAnalysis, cardCount: number): CompleteAnalysis {
  return isDraftAnalysis(prev) ? markDraft(next, cardCount) : next
}

/** The analysis without the draft mark (an explicit Analyze). */
export function clearDraft(analysis: CompleteAnalysis): CompleteAnalysis {
  if (!isDraftAnalysis(analysis) && !('draft_card_count' in analysis)) return analysis
  const { draft: _draft, draft_card_count: _count, ...rest } = analysis
  void _draft
  void _count
  return rest as CompleteAnalysis
}

/**
 * The text a New deck starts as: the command zone section and, when the
 * user pasted some, the library they have so far. Same layout the editor
 * saves (`// Commander` then `// Deck`).
 */
export function draftDecklist(commander: string, partner: string | null, library: string = ''): string {
  /* eslint-disable i18next/no-literal-string -- decklist section headers, parse grammar */
  const zone = ['// Commander', `1 ${commander}`, ...(partner ? [`1 ${partner}`] : [])].join('\n')
  const body = library.trim()
  return body ? `${zone}\n\n// Deck\n${body}` : zone
  /* eslint-enable i18next/no-literal-string */
}
